module.exports = __webpack_public_path__ + "img/Gato.67bb8aa6.gif";